<div class="filter-type-selection-body classificationFilter filter-tree">
  <div class="row">
    <div class="col-12">
      <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(industryTypeId) || null }">
        <span class="ey-float-label">
          <select
            class="form-control form-select"
            id="industryTypeId"
            name="industryTypeId"
            [disabled]="readOnly"
            (change)="industryTypeChange()"
            [(ngModel)]="filter.industryTypeId"
            required
            #industryTypeId="ngModel"
            appLabelFloat
          >
            <option *ngIf="!filter.industryTypeId" [value]="undefined" disabled selected></option>
            <option *ngFor="let industryData of industryTypes" [ngValue]="industryData.industryTypeId">
              {{ industryData.industryTypeName }}
            </option>
          </select>
          <label for="industryTypeId">Industry Type</label>
        </span>
        <span class="help-block" *ngIf="ShowValidationMessage(industryTypeId) && industryTypeId.errors.required">
          Please select a industry type
        </span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-8">
      <span>Industry Type Code:</span>
      <div class="form-group industry-type-code" [ngClass]="{ 'has-error': primary.value === undefined && submitClicked === true }">
        <div class="usrDefined">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="isPrimary_1"
              name="isPrimary"
              [value]="null"
              class="custom-control-input"
              [disabled]="readOnly"
              [(ngModel)]="filter.isPrimary"
              required
              #primary="ngModel"
            />
            <label class="custom-control-label" for="isPrimary_1">All Codes</label>
          </div>

          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="isPrimary_2"
              name="isPrimary"
              [value]="true"
              class="custom-control-input"
              [disabled]="readOnly"
              [(ngModel)]="filter.isPrimary"
              required
              #primary="ngModel"
            />
            <label class="custom-control-label" for="isPrimary_2">Primary</label>
          </div>

          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="isPrimary_3"
              name="isPrimary"
              [value]="false"
              class="custom-control-input"
              [disabled]="readOnly"
              [(ngModel)]="filter.isPrimary"
              required
              #primary="ngModel"
            />
            <label class="custom-control-label" for="isPrimary_3">Secondary</label>
          </div>
        </div>
        <span class="help-block" *ngIf="primary.value === undefined && submitClicked === true && primary.errors.required">
          Please select a industry type code
        </span>
      </div>
    </div>
    <div class="col-4">
      <label class="me-3 financial-opts">Pass If NA:</label>
      <div class="custom-control custom-radio custom-control-inline">
        <input
          type="radio"
          id="passIfNaYes"
          name="passIfNaYes"
          [value]="true"
          class="custom-control-input"
          [disabled]="readOnly"
          [(ngModel)]="filter.isPassIfNa"
        />
        <label class="custom-control-label" for="passIfNaYes">Yes</label>
      </div>
      <div class="custom-control custom-radio custom-control-inline">
        <input
          type="radio"
          id="passIfNaNo"
          name="passIfNaNo"
          [value]="false"
          class="custom-control-input"
          [disabled]="readOnly"
          [(ngModel)]="filter.isPassIfNa"
        />
        <label class="custom-control-label" for="passIfNaNo">No</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="input-group mb-3">
        <span class="ey-float-label" style="width: 42rem">
          <input type="text" class="form-control" id="filteredText" name="filteredText" [(ngModel)]="filteredText" appLabelFloat />
          <label for="filteredText"> Industry Code Search</label>
        </span>
        <div class="input-group-append">
          <button class="form-control ey-field srchbtn" type="button" (click)="getFilteredIndustryCode()">
            <i class="material-icons inputgrp-icon"> search </i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-9"></div>
    <div class="col-3 text-right">{{ filter.industryCodeSelectionId?.length || 0 }} Selected</div>
    <div class="col-6">
      <div
        [ngClass]="{
          'has-error': (filter.industryCodeSelectionId?.length === 0 || filter.industryCodeSelectionId === null) && submitClicked === true,
        }"
      >
        <div class="usrDefined">
          <p-tree
            id="industryFilter"
            name="industryFilter"
            [(value)]="industrycode_multi"
            [(selection)]="selectedIndustryCodeNodes"
            selectionMode="checkbox"
            (onNodeUnselect)="industryNodeUnselect($event)"
            (onNodeSelect)="industryNodeSelect()"
            [propagateSelectionUp]="false"
            [propagateSelectionDown]="true"
            styleClass="industry-table"
            emptyMessage="No records found"
          >
          </p-tree>
        </div>
        <span
          class="help-block"
          *ngIf="(filter.industryCodeSelectionId?.length === 0 || filter.industryCodeSelectionId === null) && submitClicked === true"
        >
          Please select a industry code
        </span>
      </div>
    </div>
    <div class="col-6">
      <p-tree
        id="selectionIndustryCodefilter"
        name="selectionIndustryCodefilter"
        class="selected-tree"
        [(value)]="filteredSelectedIndustryCodeNodes"
        (onNodeUnselect)="industryNodeUnselect($event)"
        [(selection)]="filteredSelectedIndustryCodeNodes"
        [propagateSelectionUp]="false"
        [propagateSelectionDown]="false"
        selectionMode="checkbox"
        emptyMessage=" "
        styleClass="industry-table"
      >
      </p-tree>
    </div>
  </div>
</div>
